import useCollection from 'core/hooks/useCollection'

const useLocalNotes = ({ supercaseId }) => {
  return useCollection('localNotes', { supercaseId })
}
export default useLocalNotes
